import React, { useCallback } from "react";
import { Row, Col, Card, Typography } from "antd";
import { useIntl } from "react-intl";

import ResultList from "../../app/generic/resultList";

import "./index.css";

const { Text, Paragraph } = Typography;

function SendResult({ sendResult }) {
  const intl = useIntl();
  const renderTitle = useCallback(
    (item) =>
      item.customerReference
        ? intl.formatMessage(
            {
              id: "consignment.send.withRef",
              defaultMessage: "Zásilka ref. {reference}",
            },
            { reference: item.customerReference }
          )
        : intl.formatMessage({
            id: "consignment.send.withoutRef",
            defaultMessage: "Zásilka bez reference",
          }),
    [intl]
  );
  const renderDescription = useCallback(
    (item) =>
      item.success
        ? intl.formatMessage({
            id: "consignment.send.sendSuccess",
            defaultMessage: "Export dopadl úspěšně.",
          })
        : intl.formatMessage({
            id: "consignment.send.sendError",
            defaultMessage: "Při exportu nastala chyba!",
          }),
    [intl]
  );

  return sendResult ? (
    <Row>
      <Col>
        <Row type="flex" justify="center" gutter={[0, 50]}>
          <Col>
            <Card
              className="print-card"
              title={intl.formatMessage({
                id: "consignment.send.resultTitle",
                defaultMessage: "Výsledek odeslání dat",
              })}
            >
              <Paragraph>
                {intl.formatMessage({
                  id: "consignment.send.countOfValid",
                  defaultMessage: "Počet úspěšně odeslaných zásilek:",
                })}
                &nbsp;
                <Text strong>{sendResult.countOfValid}</Text>
                &nbsp;
              </Paragraph>
              {sendResult.countOfInvalid > 0 && (
                <Paragraph>
                  {intl.formatMessage({
                    id: "consignment.send.countOfInvalid",
                    defaultMessage: "Počet neodeslaných (chybných) zásilek:",
                  })}
                  &nbsp;
                  <Text strong>{sendResult.countOfInvalid}</Text>
                  &nbsp;
                </Paragraph>
              )}
            </Card>
          </Col>
        </Row>
        <Row type="flex" justify="center" gutter={[0, 50]}>
          <Col>
            {sendResult.countOfInvalid > 0 &&
              sendResult.results &&
              sendResult.results.length > 0 && (
                <ResultList
                  pageSize={3}
                  titleMethod={renderTitle}
                  results={sendResult.results}
                  descriptionMethod={renderDescription}
                  stateMessageMethod={renderDescription}
                />
              )}
          </Col>
        </Row>
      </Col>
    </Row>
  ) : null;
}

export default SendResult;
